/* ============================================================
   PATCHPOP — Universe shared utilities
   assets/patch-pop-universe.js

   Exposes window.PatchPop with shared helpers used by every
   Patch Pop section. Loads once per page.
   ============================================================ */
(function () {
  'use strict';

  if (window.PatchPop && window.PatchPop.__initialized) return;

  var prefersReducedMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  /* ---- Single shared reveal observer ---- */
  var revealObserver = null;

  function ensureObserver() {
    if (revealObserver || !('IntersectionObserver' in window)) return revealObserver;

    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-pp-reveal-delay'), 10) || 0;
        if (delay > 0) {
          window.setTimeout(function () { el.classList.add('is-in'); }, delay);
        } else {
          el.classList.add('is-in');
        }
        revealObserver.unobserve(el);
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold:  0.1
    });

    return revealObserver;
  }

  /* Register one or more elements with the reveal observer */
  function observeReveal(root) {
    root = root || document;
    var nodes = root.querySelectorAll
      ? root.querySelectorAll('[data-pp-reveal]:not(.is-in)')
      : [];
    if (!nodes.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, function (n) { n.classList.add('is-in'); });
      return;
    }

    var obs = ensureObserver();
    Array.prototype.forEach.call(nodes, function (n) { obs.observe(n); });
  }

  /* ---- Init on DOM ready ---- */
  function init() {
    document.documentElement.classList.add('pp-universe-ready');
    observeReveal(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ---- Theme Editor: re-scan when a section is loaded ---- */
  document.addEventListener('shopify:section:load', function (event) {
    observeReveal(event.target);
  });

  /* ---- Public API ---- */
  window.PatchPop = {
    __initialized:       true,
    prefersReducedMotion: prefersReducedMotion,
    observeReveal:        observeReveal
  };
}());
